import { render } from "./WelcomeRealEstateAgent.vue?vue&type=template&id=a9bd3a48&ts=true"
import script from "./WelcomeRealEstateAgent.vue?vue&type=script&lang=ts"
export * from "./WelcomeRealEstateAgent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__